import { jsx as _jsx } from "react/jsx-runtime";
import { createFileRoute, Outlet } from '@tanstack/react-router';
import { getProjectRoutePermissions } from '@ui/guards/route-checks';
export const Route = createFileRoute('/org/$organization/$project')({
    component: Component,
    loader: async (param)=>{
        let { params, context: { queryClient } } = param;
        const permissions = await getProjectRoutePermissions(queryClient, params.organization, params.project);
        return {
            permissions
        };
    }
});
function Component() {
    return /*#__PURE__*/ _jsx(Outlet, {});
}
